import { CORRECT_PHONE_HANDLING_TOGGLE } from '@makemydeal/dr-sales-checkin-types';

export const isCorrectPhoneHandlingEnabledInState = (state?: { featureToggles?: unknown }): boolean =>
    Boolean((state?.featureToggles as Record<string, boolean | undefined> | undefined)?.[CORRECT_PHONE_HANDLING_TOGGLE]);

export const getEnableCorrectPhoneHandling = (action?: {
    payload?: { featureToggles?: Record<string, boolean | undefined> };
    meta?: { enableCorrectPhoneHandling?: boolean };
}): boolean =>
    Boolean(action?.meta?.enableCorrectPhoneHandling ?? action?.payload?.featureToggles?.[CORRECT_PHONE_HANDLING_TOGGLE]);
